import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/fredericksburg")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Fredericksburg, TX | Texas Made Shade",
      description: "Custom welded awnings, patio & pergola covers, winery shade structures and outdoor curtains for Fredericksburg & Gillespie County.",
      keywords: "pergola covers Fredericksburg, pergola covers Texas, custom pergola covers Fredericksburg, aluminum pergola covers Fredericksburg",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Fredericksburg, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Fredericksburg and Gillespie County.",
    }),
    scripts: cityHeadScripts("Fredericksburg", "Gillespie County"),
  }),
  component: () => <CityHomePage city="Fredericksburg" region="Gillespie County" />,
});
